module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/marquee/marquee-row/marquee-row.style.scss
// module id = 729
// module chunks = 2